import { render, staticRenderFns } from "./component.vue?vue&type=template&id=8d04f074&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d04f074')) {
      api.createRecord('8d04f074', component.options)
    } else {
      api.reload('8d04f074', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=8d04f074&", function () {
      api.rerender('8d04f074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-fork-me-on-github/component.vue"
export default component.exports